import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import InsightBanner from '../../components/pages/Insights/InsightBanner/InsightBanner'
import Articles from '../../components/pages/Insights/Articles/Articles'
import HaveAProject from '../../components/pages/Insights/HaveAProject/HaveAProject'

const Insights = () => {
  return (
    <div>
        <Navbar />
        <InsightBanner />
        <Articles />
        <HaveAProject />
        <Footer />
    </div>
  )
}

export default Insights